import { render, staticRenderFns } from "./PartyLanguage.vue?vue&type=template&id=09b2285d&scoped=true"
import script from "./PartyLanguage.vue?vue&type=script&lang=js"
export * from "./PartyLanguage.vue?vue&type=script&lang=js"
import style0 from "./PartyLanguage.vue?vue&type=style&index=0&id=09b2285d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2285d",
  null
  
)

export default component.exports